<template>
  <div class="form-group">
    <label for="client">
      <template v-if="isSub">
        {{ $t('ui.subSupplier') }}:
      </template>
      <template v-else>
        {{ $t('ui.supplier') }}:
      </template>
    </label>

    <validation-provider
      :rules="isSub ? null : 'required'"
      :name="isSub ? 'sub-customer-id' : 'customer-id'"
      tag="div"
      v-slot="{ errors }">
      <div
        v-if="!readOnly"
        :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
        <v-select
          :options="customers"
          v-model="customer_id"
          :reduce="customer => customer.id"
          :filterBy="filterByForCustomers"
          :placeholder="isSub ? $t('ui.selectSubSupplier') : $t('ui.selectSupplier')"
          label="name"
          @search="debouncedFetchCustomers">
          <template slot="no-options">
            <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
            <template v-if="emptyResults">{{ $t('purchase.noSupplierMarchingPhraseFound') }}&hellip;</template>
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name }} ({{ option.invoice_country_prefix }}{{ option.invoice_tax_number }})
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name }} ({{ option.invoice_country_prefix }}{{ option.invoice_tax_number }})
            </div>
          </template>
        </v-select>
      </div>
      <span class="py-2 d-block" v-else>
        {{ customerName }}
      </span>
    </validation-provider>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'purchase-select-shipper',
  props: [
    'customerName',
    'isSub',
    'readOnly'
  ],
  computed: {
    hasSewingRoomIntegration () {
      if (this.selectedCustomer) {
        return !!this.selectedCustomer.sewing_room_integrate;
      }

      return false;
    }
  },
  watch: {
    customer_id (newValue) {
      if (this.isSub) {
        this.$bus.$emit('purchase-select-sub-shipper-changed', newValue);
      } else {
        this.$bus.$emit('purchase-select-shipper-changed', newValue);
      }

      if (newValue !== 0 && newValue !== null) {
        let customerData = this.customers.filter(customer => customer.id === newValue);

        if (customerData[0]) {
          this.selectedCustomer = JSON.parse(JSON.stringify(customerData[0]));

          if (this.selectedCustomer.warehouse && !this.isSub) {
            this.$bus.$emit('purchase-select-shipper-set-warehouse', this.selectedCustomer.warehouse);
          }

          if (this.selectedCustomer.purchase_category && !this.isSub) {
            this.$bus.$emit('purchase-select-shipper-set-purchase-category', this.selectedCustomer.purchase_category);
          }
        } else {
          this.selectedCustomer = null;
          this.customer_id = null;
        }
      } else {
        this.selectedCustomer = null;
      }
    },
    hasSewingRoomIntegration (newValue) {
      this.$bus.$emit('purchase-select-shipper-sewing-room-integration-change', newValue);
    }
  },
  data () {
    return {
      customer_id: null,
      customers: [],
      emptyResults: false,
      selectedCustomer: null
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/customers/items',
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        params: {
          where: {
            is_supplier: 1
          }
        }
      });
    },
    filterByForCustomers (option, label, search) {
      return (option.name + ' ' + option.email + ' ' + option.invoice_country_prefix + option.invoice_tax_number).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    loadShipper (customerID, contactID = false, skipDataReload = false) {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/customers/item/' + parseInt(customerID, 10),
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        wrapResponseIntoArray: true,
        successAction: () => {
          if (skipDataReload && this.customer_id) {
            let customerData = this.customers.filter(customer => customer.id === this.customer_id);

            if (customerData[0]) {
              this.selectedCustomer = JSON.parse(JSON.stringify(customerData[0]));
            }
          }

          Vue.set(this, 'customer_id', parseInt(customerID, 10));

          if (!skipDataReload) {
            Vue.nextTick(() => {
              setTimeout(() => {
                this.$bus.$emit('purchase-data-fetch-success', 'customer');
                this.$bus.$emit('purchase-select-contact-set-id', contactID);
              }, 0);
            });
          }
        }
      });
    },
    fetchCustomers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/customers/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase,
          is_supplier: 1
        };
      }

      if (this.customer_id !== 0 && this.customer_id !== null && searchPhrase === '') {
        endpointUrl = '/customers/item/' + parseInt(this.customer_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchCustomers: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCustomers(searchPhrase, loadingCallback);
    }, 500)
  }
}
</script>
